import { forwardRef, useImperativeHandle } from "react";
import { CreditCard } from "lucide-react";

// Stands in for SquareCheckout on the demo school's donation form: a card
// that's already filled in, and a tokenize() that needs no provider. The
// server takes a pretend payment for demo schools (PretendDonations).
const PretendCheckout = forwardRef(function PretendCheckout(_props, ref) {
  useImperativeHandle(ref, () => ({
    async tokenize() {
      return { source_id: "pretend" };
    },
  }), []);

  return (
    <div className="space-y-1.5">
      <div className="flex h-12 items-center gap-3 rounded-lg border border-input bg-card px-4 text-sm font-tabular text-muted-foreground">
        <CreditCard className="h-4 w-4 shrink-0" aria-hidden="true" />
        <span className="flex-1">4242 4242 4242 4242</span>
        <span>12/30</span>
        <span>123</span>
      </div>
      <p className="text-xs text-muted-foreground">A pretend card for the demo. Nothing is charged.</p>
    </div>
  );
});

export default PretendCheckout;
